import { render, staticRenderFns } from "./admin_product_links.vue?vue&type=template&id=4776809c"
import script from "./admin_product_links.vue?vue&type=script&lang=js"
export * from "./admin_product_links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports